import { connect } from "react-redux";
import React, { useEffect, useState } from "react";

import { api } from "../../../../APIRequests";
import { getQueryParams } from "../../../../utils/filters";
import { toastMessageTypes } from "../../../../redux/actions/toaster";

import PostSessionSurvey from "./PostSessionSurvey";

const PostSessionSurveyWrapper = (props) => {
  const [questionSet, setQuestionSet] = useState(undefined);
  const callId = getQueryParams("callId", props.location.search);

  const errorTypeConfig = {
    MultipleSubmissionException: {
      toastErrorType: toastMessageTypes.warning,
      errorCallback: () => props.history.push("/app/home"),
    },
  };

  useEffect(() => {
    (async () => {
      const question_set = await api.shared.get_post_session_survey_question_set(
        callId,
        errorTypeConfig,
      );

      setQuestionSet(question_set);
    })();
  }, []);

  if (!questionSet) {
    return <></>;
  }

  return <PostSessionSurvey {...props} questionSet={questionSet[0]} callId={callId} />;
};

const mapStateToProps = (state) => {
  return {
    authRedirectPath: state.auth.authRedirectPath,
  };
};

export default connect(mapStateToProps, {})(PostSessionSurveyWrapper);
